$(document).ready(function ($) {
    let props = {};
    $( "input[id^='item_prop']" ).each(function() {
        let k = $( this ).attr("id").replace("item_prop", "");
        let v = $( this ).val();
        props[k] = v;
    });
    // Get the current quantity from the first text field
    let q = $('form').find('input[type=text]').filter(':visible:first').val();
    $('#shipping-select').on('change', function() {
        if (this.value == 'Shipping method') {
            $('#checkout').prop('disabled', true);
        } else {
            $('#checkout').prop('disabled', false);
            props['_selected_shipping'] = this.value;
            $.post('/cart/change.js', {
                line: 1,
                quantity: q,
                properties: props,
            })
            $.post('/cart/update.js', {
                attributes: {
                    '_shipping_methods': this.value,
                },
            })
            .done(function( data ) {
                console.log( "Data Loaded: " + data );
            });
        }
    });
});
